<script setup lang="ts">
const props = defineProps<{
  brandName?: string;
}>();

const signWithX = async () => {
  try {
    const config = useRuntimeConfig();

    const coreDomain = config.public.CORE_SPA_DOMAIN;
    // Normalize URLs by removing trailing slashes
    const normalizedCoreDomain = coreDomain.replace(/\/$/, "");
    const normalizedCurrentUrl =
      window.location.origin + window.location.pathname.replace(/\/$/, "");

    const isOnCoreDomain = normalizedCurrentUrl === normalizedCoreDomain;

    if (!isOnCoreDomain && props.brandName) {
      const utms = checkForExistingUtms();
      const params = new URLSearchParams({
        signin_from_partner: props.brandName.toLowerCase(),
        ...(utms ?? {}),
      });
      const redirectUrl = `${normalizedCoreDomain}?${params.toString()}`;
      window.location.href = redirectUrl;
      return;
    }

    const twitterResponse = await apiService.getTwitterLoginUrl({
      trigger: "button_signup_clicked",
      partnerName: props.brandName,
      domainType: props.brandName ? "partner" : "main",
      page_path: document.location.pathname,
      deviceId: useAmplitudeStore().deviceId,
      referrer: document.referrer || "",
    });
    const { redirectUrl } = twitterResponse.data;
    window.location.href = redirectUrl;
  } catch (error) {
    console.error(error);
  }
};
</script>

<template>
  <button class="text-sm" @click="signWithX">
    <slot>
      Sign up via
      <IconsTweetIcon />
    </slot>
  </button>
</template>
